import { render, staticRenderFns } from "./BasesView.vue?vue&type=template&id=159ebf6e&scoped=true"
import script from "./BasesView.vue?vue&type=script&lang=js"
export * from "./BasesView.vue?vue&type=script&lang=js"
import style0 from "./BasesView.vue?vue&type=style&index=0&id=159ebf6e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "159ebf6e",
  null
  
)

export default component.exports